export const JObWorkDataList = {
  tabs: [
    {
      label: 'All Job Work List',
      id: 1,
    },
  ],
};
